export enum DateTimeFormat {
  DATE_COMPARISON = 'YYYY-MM-DD', // aligns with moment.HTML5_FMT.DATE
  DATE_HEADER = 'dddd, MMMM D',
  DATE_NAV = 'M/D',
  DATE_ICS_FILE_NAME = 'MMDDYY',
  DATETIME_VCAL = 'YYYYMMDDTHHmmss\\Z',
  MONTH_COMPARISON = 'YYYY-MM', // aligns with moment.HTML5_FMT.MONTH
  MONTH_HEADER = 'MMMM',
  TIME_END = 'h:mma',
  TIME_START = 'h:mma',
}
